module.exports = __webpack_public_path__ + "static/media/Academic.269a6fe6.jpg";